'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _fund_document_list = require('./fund_document_list.js');

var _fund_document_list2 = _interopRequireDefault(_fund_document_list);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _url_utility = require('../../../packages/common-utilities/src/url_utility.js');

var _url_utility2 = _interopRequireDefault(_url_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _fund_documents_config = require('../../../packages/common-utilities/src/fund_documents_config');

var _disclosure = require('./disclosure');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _url_utility3 = require('common-utilities/src/url_utility');

var _reactIntl = require('react-intl');

var _collection_utility = require('common-utilities/src/collection_utility');

var _fund_utility = require('common-utilities/src/fund_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _reactCollapsible = require('react-collapsible');

var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _tracking_utility = require('../../../packages/common-utilities/src/tracking_utility');

var _state_service = require('../services/state_service');

var _state_service2 = _interopRequireDefault(_state_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var URL_SIGNUP = "/us/en/asset-management/adv/auth/login-form";

var FundDocuments = function (_React$Component) {
  _inherits(FundDocuments, _React$Component);

  function FundDocuments(props) {
    _classCallCheck(this, FundDocuments);

    var _this = _possibleConstructorReturn(this, (FundDocuments.__proto__ || Object.getPrototypeOf(FundDocuments)).call(this, props));

    _this.renderRegulatoryDocuments = function () {
      if (_this.props.fundTypeCode === "Commingled") {
        return (0, _url_utility3.getCommingledRegulatoryDocumentLinks)(_this.props.cusip, _this.props.role);
      }

      return _url_utility2.default.getRegulatoryDocumentLinks(_this.props.cusip, _this.props.role);
    };

    _this.hasCusipInDocumentObject = function (obj) {
      if ((0, _ramda.isNil)(obj)) {
        return false;
      }

      var cusipUpperCase = (0, _ramda.toUpper)(_this.props.cusip);
      return (0, _ramda.has)(cusipUpperCase)(obj);
    };

    _this.renderDocumentCard = function (headerTitle, headerTitleId, dataTest, documents, disclosureId, fullWidth, leavingSiteOverlay) {
      if ((0, _functional_utility.isDataEmpty)(documents)) {
        return null;
      }

      var noOfColumns = headerTitleId === "reportsAndAccountsDocuments" ? 4 : 2;
      if (_collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, "SHOW_COUNTRY_ROLE_SPECIFIC_DOCUMENTS_ORDERING") && headerTitleId === "fundLiteratureDocuments") {
        noOfColumns = 1;
      }
      var documentsSection = _react2.default.createElement(
        'div',
        { id: headerTitleId + "Card" },
        _react2.default.createElement(_fund_document_list2.default, { documents: documents,
          userLoggedIn: _this.props.userLoggedIn,
          isOrderedList: _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, "SHOW_COUNTRY_ROLE_SPECIFIC_DOCUMENTS_ORDERING"),
          headerTitleId: headerTitleId,
          visibleDataPoints: _this.props.visibleDataPoints,
          role: _this.props.role,
          basePath: _this.props.basePath,
          window: _this.props.window,
          breakpoint: _this.props.breakpoint,
          cmsHost: _this.props.cmsHost,
          isAEM: _this.props.isAEM,
          leavingSiteOverlay: leavingSiteOverlay,
          defaultStyle: "category document-tab-link",
          textColorClass: "font-super-black",
          showDownloadIcon: true,
          noOfColumns: _this.props.breakpoint < 3 ? 1 : noOfColumns,
          isDocumentTabCard: true,
          intl: _this.props.intl,
          language: _this.props.language,
          country: _this.props.country
        }),
        _react2.default.createElement(_disclosure2.default, { disclosureText: (0, _ramda.isNil)(_this.props.disclosure) ? null : _this.props.disclosure[disclosureId], placementId: disclosureId,
          shouldAlwaysShowMore: !(0, _ramda.isNil)(_this.props.visibleDataPoints) && _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, "SHOW_DISCLOSURE_ON_DOCUMENT_LEGAL_CARD") ? true : false })
      );

      return _react2.default.createElement(
        'div',
        { 'data-testid': dataTest, className: "padding-bottom-30" },
        _this.renderCollapsibleComponent(headerTitleId, headerTitle, documentsSection)
      );
    };

    _this.renderGenericDocumentCards = function () {
      var documents = (_this.props.fundDocuments || {}).documents || [];

      documents = documents.sort(function (a, b) {
        var dateKeyA = (0, _ramda.isNil)(a.date) ? '' : a.date;
        var dateKeyB = (0, _ramda.isNil)(b.date) ? '' : b.date;
        if (dateKeyA === dateKeyB) {
          var titleKeyA = (0, _ramda.isNil)(a.title) ? '' : a.title;
          var titleKeyB = (0, _ramda.isNil)(b.title) ? '' : b.title;
          if (titleKeyA === titleKeyB) {
            return 0;
          }
          return titleKeyA > titleKeyB ? -1 : 1;
        }
        return dateKeyA < dateKeyB ? -1 : 1;
      });
      documents = documents.reverse();
      if ((0, _functional_utility.isDataEmpty)(documents)) {
        return null;
      } else {
        var cards = _this.getDocumentsByCards(documents);

        var numberOfCols = 3;
        var cols = [];
        for (var i = 0; i < numberOfCols; ++i) {
          cols.push(_this.renderGenericDocumentCardsColumn(cards, i));
        }

        return cols;
      }
    };

    _this.renderDocumentCardsColumn = function (cards, index) {
      return _react2.default.createElement(
        'div',
        null,
        cards.map(function (item) {
          if (item.columnIndex === index) {
            if ((0, _ramda.isNil)(item.cardTitle)) {
              return null;
            }
            return _this.renderDocumentCard(item.cardTitle, item.cardTitleId, item.dataTest, _this.getDocumentList(item), item.disclosureId, true, item.leavingSiteOverlay);
          }
        })
      );
    };

    _this.renderGenericDocumentCardsColumn = function (cards, index) {

      return _react2.default.createElement(
        'div',
        null,
        cards.map(function (item) {
          if (item.columnIndex === index) {
            if ((0, _ramda.isNil)(item.headerTitle)) {
              return null;
            }
            return _this.renderDocumentCard(item.headerTitle, item.dataTestId, item.dataTestId, item.documents, item.disclosureId, true, item.leavingSiteOverlay);
          }
        })
      );
    };

    _this.getDocumentsByCards = function (documents) {
      var configs = (0, _fund_documents_config.getFundDocumentConfig)(_this.props.country, _this.props.role, _this.props.fundTypeCode, _this.props.cmsShare, _this.props.visibleDataPoints, _this.props.factsheetUrl);
      documents.map(function (item) {
        configs.map(function (invItem) {
          if (item.docCategories.includes(invItem.cardCategory) && !item.docCategories.includes("Share class factsheet")) {
            invItem.documents.push(item);
          }
        });
      });
      return configs;
    };

    _this.state = {};
    _this.renderCollapsibleComponent = _this.renderCollapsibleComponent.bind(_this);
    _this.trackGA = _this.trackGA.bind(_this);
    if (!(0, _ramda.isNil)(_this.props.visibleDataPoints) && _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, "SHOW_SUBSCRIPTION_TO_LITERATURE_CTA")) {
      _this.globalStateSubscription = _state_service2.default.getGlobalState$().subscribe(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (state.docTabActionSource === 'subscribeToProductCTA') {
          _this.setState({
            docTabActionSource: state.docTabActionSource
          }, function () {
            _functional_utility2.default.scrollToCard(window.document, 'documents', 'documents-tab', _this.props.breakpoint);
          });
        }
      });
    }
    return _this;
  }

  _createClass(FundDocuments, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.globalStateSubscription && this.globalStateSubscription.unsubscribe) {
        this.globalStateSubscription.unsubscribe();
      }
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId, ariaText) {
      var _this2 = this;

      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide padding-left-2',
          role: 'button',
          'aria-label': 'more information about ' + ariaText,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId) {
      var el = event.target;

      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (this.props.disclosure[tooltipId][0].length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      if (!(0, _ramda.isNil)(this.props.tooltip)) {
        this.props.tooltip.openTooltip(elOffset, this.props.disclosure[tooltipId], null, true, event);
      }
    }
  }, {
    key: 'trackGA',
    value: function trackGA() {
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": "Documents subscription Log in or sign up",
        "eventLabel": 'from ' + window.location.href
      });
    }
  }, {
    key: 'renderSubscribeTextAndIcon',
    value: function renderSubscribeTextAndIcon() {
      var _this3 = this;

      var signUpURL = this.props.cmsHost + URL_SIGNUP;
      var nonHyperlinkedText = " to subscribe to product literature";
      var hyperlinkText = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? "Log in" : "Log in or sign up";
      var checkMobileLoggedIn = this.props.userLoggedIn && this.props.breakpoint < 4;
      return checkMobileLoggedIn ? _react2.default.createElement(
        'div',
        { 'data-testid': 'loggedin-mobile-subscription' },
        'Subscribe to product literature'
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          {
            className: 'font-teal padding-top-5',
            'data-testid': 'banner-url-redirection',
            target: '_self',
            href: signUpURL,
            onClick: function onClick() {
              _this3.trackGA();
            }
          },
          hyperlinkText
        ),
        nonHyperlinkedText,
        _react2.default.createElement(
          'span',
          { className: 'padding-left-10 float-right vertical-align-top',
            'data-testid': 'product-literature-sign-up-pop-up' },
          ' ',
          this.renderIcon("pdpFundLiteratureBannerDisclosure", "Login or sign up to subscribe to product literature banner")
        )
      );
    }
  }, {
    key: 'renderFundLiteratureSignUpBanner',
    value: function renderFundLiteratureSignUpBanner() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_DOCUMENT_SPECIFIC_BANNER') && !(this.props.userLoggedIn && !(this.props.breakpoint < 4))) {
        return _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 rounded-corner-banner' },
          _react2.default.createElement('span', { className: 'vertical-align-middle icon-notify-bell float-left padding-right-10', 'data-testid': 'icon-bell' }),
          _react2.default.createElement(
            'div',
            { className: 'vertical-align-middle', 'data-testid': 'product-literature-subscription-banner' },
            _react2.default.createElement(
              'span',
              { className: 'font-light caption padding-top-5 vertical-align-top', 'data-testid': 'banner-login-prompt',
                style: { 'lineHeight': (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? '2.0' : '1.75' } },
              this.renderSubscribeTextAndIcon()
            )
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderCollapsibleComponent',
    value: function renderCollapsibleComponent(tab, label, pane) {
      var _this4 = this;

      var collapsibleStyles = "sub-header-3 position-relative-important width-100pct text-left";
      this.props.disclosure['pdpFundLiteratureBannerDisclosure'] = _string_utility2.default.getLocalizedString(this.props.intl, "Get notified when updated literature is available", "pdp-documents-fund-literature-banner-disclosure");
      this[tab] = _react2.default.createRef();
      var propObject = {
        'id': tab,
        'aria-expanded': false
      };

      var containerElemProps = {
        'ref': this[tab],
        'onKeyDown': function onKeyDown(event) {
          return _accessibility_utility2.default.handleAccordionEvents(_this4, event, '#' + tab + '_accordion', tab, 'overview', _this4.handleTriggerClick.bind(_this4, tab));
        }
      };

      var isFromSubscribeToProductCTA = this.state.docTabActionSource === 'subscribeToProductCTA' && tab === 'fundLiteratureDocuments';
      var additionalProps = {};
      if (isFromSubscribeToProductCTA) {
        additionalProps = { key: tab + this.state.docTabActionSource };
      }
      var open = isFromSubscribeToProductCTA || (0, _functional_utility.doesFormattingRulesContain)('DOCUMENT_TAB_INITIAL_EXPAND', this.props, ["formattingRules"]);

      return _react2.default.createElement(
        _reactCollapsible2.default,
        _extends({}, additionalProps, {
          containerElementProps: containerElemProps,
          triggerElementProps: propObject,
          accordionPosition: tab,
          triggerClassName: collapsibleStyles,
          triggerOpenedClassName: collapsibleStyles,
          trigger: _react2.default.createElement(
            'span',
            { 'data-testid': tab, className: "float-left max-width-percent-90" },
            label
          ),
          triggerTagName: "button",
          className: '' + tab,
          openedClassName: '' + tab,
          transitionTime: 100,
          contentHiddenWhenClosed: false,
          onOpen: this.openHandle.bind(this, tab),
          onClose: this.closeHandle.bind(this, tab),
          open: open
        }),
        tab === "fundLiteratureDocuments" && this.renderFundLiteratureSignUpBanner(),
        pane
      );
    }
  }, {
    key: 'openHandle',
    value: function openHandle(accordionPosition) {
      document.getElementById(accordionPosition).setAttribute('aria-expanded', 'true');
    }
  }, {
    key: 'closeHandle',
    value: function closeHandle(accordionPosition) {
      document.getElementById(accordionPosition).setAttribute('aria-expanded', 'false');
    }
  }, {
    key: 'handleTriggerClick',
    value: function handleTriggerClick(accordionPosition) {
      document.getElementById(accordionPosition).click();
      if (this.state.currentTab === accordionPosition) {
        this.setState({ currentTab: null });
      } else {
        this.setState({
          currentTab: accordionPosition
        });
      }
    }
  }, {
    key: 'appendFactSheet',
    value: function appendFactSheet(fundInformationDocuments) {
      var factsheetNode = [{
        docCategories: ["Share class factsheet"],
        docURL: this.props.factsheetUrl,
        title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label', { role: this.props.role })
      }];

      if ((0, _ramda.isNil)(fundInformationDocuments)) {
        return factsheetNode;
      }

      if (FundDocuments.containsStringInDocumentCategory(fundInformationDocuments, "docCategories", "Share class factsheet")) {
        fundInformationDocuments = fundInformationDocuments.filter(function (currentObject) {
          return !_collection_utility.CollectionUtility.includes(currentObject.docCategories, "Share class factsheet");
        });
      }

      return [].concat(factsheetNode, _toConsumableArray(fundInformationDocuments));
    }
  }, {
    key: 'appendKIID',
    value: function appendKIID(regulatoryDocuments) {
      var kiidNode = [{
        docCategories: ["Key  Investor Information Document"],
        docURL: this.props.kiidUrl,
        title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label')
      }];

      if ((0, _ramda.isNil)(regulatoryDocuments)) {
        return kiidNode;
      }

      if (FundDocuments.containsStringInDocumentCategory(regulatoryDocuments, "docCategories", "Key Investor Information Document")) {
        regulatoryDocuments = regulatoryDocuments.filter(function (currentObject) {
          return !_collection_utility.CollectionUtility.includes(currentObject.docCategories, "Key Investor Information Document");
        });
      }

      return [].concat(kiidNode, _toConsumableArray(regulatoryDocuments));
    }
  }, {
    key: 'shouldAppendKIID',
    value: function shouldAppendKIID() {
      return !(0, _ramda.isNil)(this.props.visibleDataPoints) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "APPEND_KIID");
    }
  }, {
    key: 'processSupplementalInformationDocuments',
    value: function processSupplementalInformationDocuments() {
      if ((0, _ramda.and)(!(0, _ramda.isNil)(this.props.formNMFPLink), !(0, _ramda.isNil)(this.props.fundName))) {
        return (0, _ramda.insert)(0, {
          title: "Form N-MFP - " + this.props.fundName.replace("JPMorgan ", ""),
          docURL: this.props.formNMFPLink,
          isGlassDoor: false
        }, this.props.fundDocuments.supplementalInformationDocuments || []);
      }
      return this.props.fundDocuments.supplementalInformationDocuments;
    }
  }, {
    key: 'getRegulatoryDocumentsList',
    value: function getRegulatoryDocumentsList(regulatoryDocuments) {
      var regulatoryDocs = regulatoryDocuments;

      if (!(0, _ramda.isNil)(this.props.visibleDataPoints) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "LEGAL_DOCS")) {
        if (this.shouldAppendKIID()) {
          regulatoryDocs = this.appendKIID(regulatoryDocuments);
        }
      } else {
        regulatoryDocs = this.renderRegulatoryDocuments();
      }

      return regulatoryDocs;
    }
  }, {
    key: 'renderDocumentCards',
    value: function renderDocumentCards() {

      var documentCards = [];
      var fundDocumentConfig = (0, _fund_documents_config.getFundDocumentTabConfig)(this.props);

      if (fundDocumentConfig.filter(function (docCard) {
        return !(0, _ramda.isNil)(docCard.columnIndex);
      }).length === 0) {
        for (var index = 0; index < fundDocumentConfig.length; index++) {
          var documentCardConfig = fundDocumentConfig[index];
          var documentList = this.getDocumentList(documentCardConfig);
          documentCards.push(this.renderDocumentCard(documentCardConfig.cardTitle, documentCardConfig.cardTitleId, documentCardConfig.dataTest, documentList, documentCardConfig.disclosureId, null, documentCardConfig.leavingSiteOverlay));
        }
        return documentCards;
      } else {
        var numberOfCols = 3;
        var cols = [];
        for (var i = 0; i < numberOfCols; ++i) {
          cols.push(this.renderDocumentCardsColumn(fundDocumentConfig, i));
        }

        return cols;
      }
    }
  }, {
    key: 'getDocumentList',
    value: function getDocumentList(documentCardConfig) {
      var _this5 = this;

      var documentTag = _constants2.default.getFdTagConstants();
      var documentList = [];
      var content = this.props.content;
      if (this.props.country === 'cn') {
        content.documents = this.props.fundDocuments.documents;
      } else if (!(0, _functional_utility.isNilOrEmpty)(this.props.fundDocuments) && !(0, _functional_utility.isNilOrEmpty)(this.props.fundDocuments.documents)) {
        content.documents = this.props.fundDocuments.documents;
      }
      var cusip = (0, _ramda.toUpper)(this.props.cusip);
      var dataArr = !(0, _functional_utility.isNilOrEmpty)(content) && (0, _functional_utility.isObjectAndHasProp)(content.documents, cusip) ? content.documents[cusip] : null;

      if (!(0, _functional_utility.isNilOrEmpty)(documentCardConfig.documents) && ((0, _functional_utility.isNilOrEmpty)(documentCardConfig.fundTypes) || (0, _ramda.includes)(this.props.fundTypeCode, documentCardConfig.fundTypes))) {
        for (var documentCardConfigIndex = 0; documentCardConfigIndex < documentCardConfig.documents.length; documentCardConfigIndex++) {
          if (!(0, _functional_utility.isNilOrEmpty)(documentCardConfig.documents[documentCardConfigIndex].docURL)) {
            if ((0, _fund_utility.isJPETF)(this.props.country, this.props.fundTypeCode)) {
              documentCardConfig.documents[documentCardConfigIndex].docURL = documentCardConfig.documents[documentCardConfigIndex].docURL.replace("`CUSIP`", this.props.jpETFCusip);
            } else if (!(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("QUICK_LINK_SHOW_FUND_STORY", this.props.visibleDataPoints) && !(0, _functional_utility.isNilOrEmpty)(dataArr) && !(0, _functional_utility.isNilOrEmpty)((0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
              return x === documentTag.FUND_STORY;
            }, 'documentType'), dataArr))) {
              continue;
            }
            documentList.push(documentCardConfig.documents[documentCardConfigIndex]);
          } else if (!(0, _functional_utility.isNilOrEmpty)(dataArr)) {
            (function () {
              var configNode = documentCardConfig.documents[documentCardConfigIndex];
              var docCategory = configNode.docCategory,
                  documentType = configNode.documentType,
                  languageOrders = configNode.languageOrders,
                  replaceTextWithCusip = configNode.replaceTextWithCusip;

              if ((0, _functional_utility.isNilOrEmpty)(languageOrders)) {
                // const filteredDocs = filter(propSatisfies(x => x === documentType, 'documentType'), dataArr);
                var filteredDocs = [];
                if (!(0, _functional_utility.isNilOrEmpty)(docCategory) && !(0, _functional_utility.isNilOrEmpty)(documentType)) {
                  filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return !(0, _functional_utility.isNilOrEmpty)(x) && x.includes(documentType);
                  }, 'documentType'), (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return !(0, _functional_utility.isNilOrEmpty)(x) && x.includes(docCategory);
                  }, 'docCategory'), dataArr));
                } else if (!(0, _functional_utility.isNilOrEmpty)(docCategory)) {
                  filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return !(0, _functional_utility.isNilOrEmpty)(x) && x.includes(docCategory);
                  }, 'docCategory'), dataArr);
                } else if (!(0, _functional_utility.isNilOrEmpty)(documentType)) {
                  filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === documentType;
                  }, 'documentType'), dataArr);
                }

                filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                  return x === _this5.props.language || (0, _ramda.isNil)(x);
                }, 'language'), filteredDocs);

                if (!(0, _functional_utility.isNilOrEmpty)(replaceTextWithCusip)) {
                  filteredDocs = filteredDocs.map(function (doc) {
                    if (doc.docURL.indexOf(replaceTextWithCusip) !== -1) {
                      doc.docURL = doc.docURL.replace(replaceTextWithCusip, _this5.props.cusip.toUpperCase());
                    }
                    return doc;
                  });
                }

                documentList = [].concat(_toConsumableArray(documentList), _toConsumableArray(filteredDocs));
                if (!(0, _ramda.isNil)(documentCardConfig.sortOrder)) {
                  documentList = _collection_utility.CollectionUtility.sort(documentList, 'title', documentCardConfig.sortOrder);
                }
                if (!(0, _ramda.isNil)(documentCardConfig.sortByDateOrder)) {
                  documentList = _collection_utility.CollectionUtility.sort(documentList, 'onDate', documentCardConfig.sortByDateOrder);
                }
              } else {
                languageOrders.forEach(function (language) {
                  var filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === documentType;
                  }, 'documentType'), dataArr);
                  filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                    return x === language;
                  }, 'language'), filteredDocs);
                  documentList = [].concat(_toConsumableArray(documentList), _toConsumableArray(filteredDocs));
                });
              }
            })();
          }
        }
      }

      return documentList;
    }
  }, {
    key: 'renderForEmptyDocuments',
    value: function renderForEmptyDocuments() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 print-hide' },
          _react2.default.createElement(
            'div',
            { className: 'col-lg-12 col-xlg-12 ' + (this.props.breakpoint < 4 ? "margin-all-0" : "") + ' print-full-width' },
            _react2.default.createElement(
              _card_component2.default,
              {
                headerTitle: 'Documents',
                headerTitleId: 'fund-document-error',
                breakpoint: this.props.breakpoint
              },
              _react2.default.createElement(
                'div',
                { 'data-testid': 'document-error-div' },
                'Documents are currently unavailable.'
              )
            )
          )
        ),
        (0, _ramda.and)(!(0, _ramda.isNil)((0, _ramda.pathOr)(null, ["pdpDocument"], this.props.disclosure)), this.props.fundTypeCode === 'Mainland_HK_MRF_FUNDS') && _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosure.pdpDocument, placementId: 'pdpDocument' })
        )
      );
    }
  }, {
    key: 'renderDocumentsFromOWCS',
    value: function renderDocumentsFromOWCS() {
      var _props$fundDocuments = this.props.fundDocuments,
          internalUseOnlyDocuments = _props$fundDocuments.internalUseOnlyDocuments,
          regulatoryDocuments = _props$fundDocuments.regulatoryDocuments;

      var supplementalInformationDocuments = this.processSupplementalInformationDocuments();
      var regulatoryDocumentsList = this.getRegulatoryDocumentsList(regulatoryDocuments);
      var fundInformationDocumentsList = this.getFundInformationDocuments;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 padding-left-0 padding-right-0 print-hide',
            'data-testid': 'document-parent-div' },
          (0, _ramda.and)(this.props.fundTypeCode !== '529 Plans', !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "IS_SUPPRESSION_NON_529_FUND_LITERATURE")) ? this.renderDocumentCard(_string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label', { role: this.props.role }), "fundLiteratureDocuments", "fund-literature-documents", fundInformationDocumentsList) : null,
          this.renderDocumentCard("Supplemental Information", "supplementalInformationDocuments", "supplemental-information-documents", supplementalInformationDocuments),
          (0, _ramda.and)(this.props.fundTypeCode !== '529 Plans', !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "IS_SUPPRESSION_REGULATORY_DOCUMENT")) ? this.renderDocumentCard(_string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'), "regulatoryDocuments", "regulatory-documents", regulatoryDocumentsList) : null,
          this.props.role === _constants2.default.getOrionRole() ? this.renderDocumentCard("Internal Use Only", "internalUseOnlyDocuments", "internal-use-only-documents", internalUseOnlyDocuments) : null,
          !(0, _ramda.isNil)(this.props.visibleDataPoints) && (0, _ramda.includes)('SHOW_INSIGHTS_CARD', this.props.visibleDataPoints) && this.renderDocumentCard(_string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'), 'insights', 'insights-documents', (0, _fund_documents_config.getInsightsConfig)())
        ),
        (0, _ramda.and)(!(0, _ramda.isNil)((0, _ramda.pathOr)(null, ["pdpDocument"], this.props.disclosure)), this.props.fundTypeCode === 'Mainland_HK_MRF_FUNDS') && _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosure.pdpDocument, placementId: 'pdpDocument' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.fundDocuments)) {
        return this.renderForEmptyDocuments();
      } else if (this.props.isAEM && !(0, _functional_utility.isNilOrEmpty)((0, _fund_documents_config.getFundDocumentTabConfig)(this.props))) {
        var shouldShowAssessmentReportFootnote = !(0, _ramda.isNil)(this.props.visibleDataPoints) && (0, _ramda.includes)('DOCUMENT_TAB_ASSESSMENT_VALUE_REPORT_LINK_FOOTNOTE', this.props.visibleDataPoints);
        return _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 padding-left-0 padding-right-0 print-hide',
            'data-testid': 'document-parent-div' },
          _react2.default.createElement(
            'div',
            { id: "documents-card",
              className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-left-0 ' + (this.props.breakpoint < 4 ? "margin-all-0" : "") + ' print-full-width',
              'data-testid': 'document-child-div' },
            _react2.default.createElement(
              _card_component2.default,
              {
                headerTitle: _string_utility2.default.renderFormattedLabel("Documents", "pdp-documents-tab-label"),
                headerTitleId: "documents-card-component",
                breakpoint: this.props.breakpoint
              },
              this.renderDocumentCards(),
              shouldShowAssessmentReportFootnote && _react2.default.createElement('span', {
                className: 'disclosure display-inline-block disclaimer margin-top-15',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(_string_utility2.default.getLocalizedString(this.props.intl, '', "pdp-documents-assessment-report-footnote", { role: this.props.role })) } })
            )
          )
        );
      } else if ((0, _ramda.and)(!(0, _ramda.isNil)(this.props.visibleDataPoints), _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "GENERIC_DOCUMENT_CARDS"))) {
        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderGenericDocumentCards(),
            _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosure.pdpDocument, placementId: 'pdpDocument' })
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { id: "documents-card",
            className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-left-0 ' + (this.props.breakpoint < 4 ? "margin-all-0" : "") + ' print-full-width',
            'data-testid': 'document-child-div' },
          _react2.default.createElement(
            _card_component2.default,
            {
              headerTitle: _string_utility2.default.renderFormattedLabel("Documents", "pdp-documents-tab-label"),
              headerTitleId: "documents-card-component",
              breakpoint: this.props.breakpoint
            },
            this.renderDocumentsFromOWCS()
          )
        );
      }
    }

    // factsheet document is added by default from the config file

  }, {
    key: 'getFundInformationDocuments',
    get: function get() {
      var fundDocuments = this.props.fundDocuments;
      var fundInformationDocuments = fundDocuments.fundInformationDocuments;

      var documents = void 0;

      if (!(0, _ramda.isNil)(this.props.visibleDataPoints) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "PRODUCT_DOCS")) {
        documents = this.appendFactSheet(fundInformationDocuments);
      } else {
        documents = fundInformationDocuments;
      }

      return documents;
    }
  }], [{
    key: 'containsStringInDocumentCategory',
    value: function containsStringInDocumentCategory(arr, attribute, documentString) {
      for (var i = 0; i < arr.length; i++) {
        var node = arr[i];
        if (node.hasOwnProperty(attribute) && Array.isArray(node[attribute])) {
          var documentCategory = node[attribute];
          for (var j = 0; j < documentCategory.length; j++) {
            if (documentCategory[j] === documentString) {
              return true;
            }
          }
        }
      }
      return false;
    }
  }]);

  return FundDocuments;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(FundDocuments, { withRef: true });